import { Dropdown } from "primereact/dropdown";
import { useMemo } from "react";
import Alert, { AlertType } from "../../../components/Alert";

const OrderSelectionSection = ({ orders, selectedOrder = null, handleSelectedOrder }) => {
	const matchedOrder = useMemo(() => {
		if (!selectedOrder) {
			return null;
		}
		return orders.find(
			(order) =>
				order.RowKey === selectedOrder.TableRowKey &&
				order.str_sageorderid === selectedOrder.OrderId
		) || null;
	}, [selectedOrder, orders]);

	return (
		<>
			<h4>Select Order</h4>
			<p>Select an order id to link this company to. This needs to be done for all Cloud Work and Cloud Voice orders received via the API to ensure accurate billing.</p>
			{orders.length > 0 ? (
				<Dropdown
					value={matchedOrder}
					options={orders}
					optionLabel="str_sageorderid"
					placeholder="Select an Order"
					optionDisabled={(x) => x.ExistsInDatabase === false}
					onChange={(e) => handleSelectedOrder(e.value)}
				/>
			) : (
				<Alert type={AlertType.Information}>No orders were found in CRM.</Alert>
			)}
		</>
	);
};

export default OrderSelectionSection;